import { createLiveStore } from "../lib/live-store";
import type { AssetIndexResponse } from "../types/asset-table";
import type { AssetListFilter } from "../types/api";

interface AssetIndexExtra {
  filter: AssetListFilter;
  setFilter: (filter: AssetListFilter) => void;
}

export const useAssetIndexStore = createLiveStore<AssetIndexResponse, AssetIndexExtra>({
  topic: "assets.index",
  params: (s) => s.filter,
  onSnapshot: (data) => data as AssetIndexResponse,
  onEvent: (event, state) => {
    if (typeof event !== "object" || !event) return null;
    const evt = event as { action: string; id?: number };
    if (evt.action === "deleted" && evt.id !== undefined) {
      const filtered = state.assets.filter((a) => a.asset_id !== evt.id);
      if (filtered.length < state.assets.length) {
        return { assets: filtered, total: state.total - 1 };
      }
      return {};
    }
    return null;
  },
  state: (set) => ({
    assets: [],
    total: 0,
    filter: {} as AssetListFilter,
    setFilter: (filter: AssetListFilter) => set({ filter } as any),
  }),
});
